import { render } from "./kd-hide-sensitivity-input.vue?vue&type=template&id=21107128"
import script from "./kd-hide-sensitivity-input.vue?vue&type=script&lang=js"
export * from "./kd-hide-sensitivity-input.vue?vue&type=script&lang=js"
script.render = render

export default script